import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, containerVariants } from '../constants/animations';
import './ServicePages.css';

export default function ServicePageLayout({ title, subtitle, children }) {
  return (
    <main className="service-page">
      <div className="service-container">
        <motion.div
          className="service-hero"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.25 }}
          variants={containerVariants}
        >
          <motion.h1 variants={fadeInUp}>{title}</motion.h1>
          <motion.p variants={fadeInUp}>{subtitle}</motion.p>
        </motion.div>
        {children}
      </div>
    </main>
  );
}
